import { render, staticRenderFns } from "./AdminPanelDashboardDialogCreate.vue?vue&type=template&id=0570a73d"
import script from "./AdminPanelDashboardDialogCreate.vue?vue&type=script&lang=js"
export * from "./AdminPanelDashboardDialogCreate.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDashboardDialogCreate.vue?vue&type=style&index=0&id=0570a73d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports